import { Spinner } from 'src/common/components'
import dayjs from 'src/common/libs/dayjs'

import styles from './nyc-license-lookup-result.module.scss'

import { useGetNycLookupLicenseQuery } from '@v2/domains/documents/api/documents.api'
import type { NycLookupLicenseResponse } from '@v2/domains/documents/documents.types'

interface NycLicenseLookupResultWrapperProps {
  findBy: string
  findValue: string
}

const NycLicenseLookupResultWrapper = (
  props: NycLicenseLookupResultWrapperProps,
) => {
  const { findBy, findValue } = props

  const { currentData: data, isFetching } = useGetNycLookupLicenseQuery(
    { findBy, findValue: findValue ? String(findValue) : '' },
    { skip: !findBy || !findValue },
  )
  const isLoading = isFetching && !data

  //const showResult = false

  return (
    <div
      className={styles.wrapper}
      data-testid="nyc-license-lookup-results-list"
    >
      {isLoading ? (
        <div className={styles.spinnerContainer}>
          <Spinner color="primary" size="normal" />
        </div>
      ) : (
        <NycLicenseLookupResult data={data ?? null} />
      )}
    </div>
  )
}

interface NycLicenseLookupResultProps {
  data: NycLookupLicenseResponse | null
}

const NycLicenseLookupResult = (props: NycLicenseLookupResultProps) => {
  const { data } = props

  if (!data?.id) {
    return (
      <div
        className={styles.resultsContainer}
        data-testid="nyc-license-lookup-not-found-label"
      >
        <div className={styles.errorMessage}>
          Driver is not found in NYC Open Data
        </div>
      </div>
    )
  }

  if (data.id) {
    const transformDate = (date?: string) => {
      if (!date) {
        return dayjs()
      }
      const [simpleDate] = date.split('T')
      return dayjs(simpleDate)
    }
    return (
      <div
        className={styles.resultContainer}
        data-testid="nyc-license-lookup-result-card"
      >
        <div className={styles.name}>
          {data.name} - {data.licenseNumber}
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.titles}>Expiration date:</div>
          <div className={styles.infoDates}>
            {transformDate(data.expirationDate).format('MMM DD, YYYY')}
          </div>
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.titles}>Last Update:</div>
          <div className={styles.infoDates}>
            {transformDate(data.lastDateUpdated).format('MMM DD, YYYY')}
          </div>
        </div>
        <div>
          {data.isActive ? (
            <h3 className={styles.active}>ACTIVE</h3>
          ) : (
            <h3 className={styles.inactive}>INACTIVE</h3>
          )}
        </div>
      </div>
    )
  }

  return null
}

export default NycLicenseLookupResultWrapper
